











































import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue, { PropType } from 'vue';
import { LessonEntity } from '@/entities/lesson.entity';
import { LessonTestResultEntity } from '@/entities/lesson-test-result.entity';

@Component<TestIntroduce>({})
export default class TestIntroduce extends Vue {
  @Prop({ type: Object as PropType<LessonEntity> })
  lesson: LessonEntity;

  lessonTestResults: LessonTestResultEntity[] = null;

  loading = true;

  get totalTime() {
    return Math.ceil((this.lesson.totalTime || 0) / 60);
  }

  @Watch('lesson')
  async handle(val) {
    if (val) {
      this.loading = false;
    }
  }

  async confirmFunc() {
    const res = await this.$http.get(`/lesson-test-result?filter=lessonId||$eq||${this.lesson.id}`);
    this.lessonTestResults = res.data;
    if (this.lessonTestResults.length) {
      await Promise.all(
        this.lessonTestResults.map((lessonTestResult) =>
          this.$http.delete(`/lesson-test-result/${lessonTestResult.id}`),
        ),
      );
    }
    this.$emit('confirm');
  }
}
